import { LogoMark } from "./Nav";

export default function Footer({ scrollTo }) {
  return (
    <footer className="border-t border-white/10 bg-[#0A0B0E]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <LogoMark />
              <span className="font-display font-extrabold tracking-tight leading-none">
                MOBILE ONE
                <span className="block font-tech text-[10px] tracking-[0.4em] text-[#FF5500] font-medium mt-1">
                  AUDIO
                </span>
              </span>
            </div>
            <p className="mt-5 text-sm text-white/50 leading-relaxed max-w-xs">
              Custom audio & auto upgrades done right. Clean installs, quality parts,
              zero shortcuts.
            </p>
          </div>
          <div>
            <p className="font-tech text-[10px] uppercase tracking-[0.3em] text-[#FF5500] mb-4">
              Services
            </p>
            <ul className="space-y-2 text-sm text-white/60">
              <li>Car stereo installation</li>
              <li>Subwoofer builds & enclosures</li>
              <li>Wraps, rims & window tint</li>
              <li>LED lighting & fabrication</li>
              <li>Home audio / video automation</li>
            </ul>
          </div>
          <div>
            <p className="font-tech text-[10px] uppercase tracking-[0.3em] text-[#FF5500] mb-4">
              Pull Up
            </p>
            <p className="text-sm text-white/60 leading-relaxed">
              867 S Dupont Hwy, Unit 2
              <br />
              New Castle, DE 19720
            </p>
            <a
              data-testid="footer-call-link"
              href="tel:3022686466"
              className="mt-3 inline-block font-display text-lg font-bold text-white hover:text-[#FF5500] transition-colors"
            >
              (302) 268-6466
            </a>
          </div>
        </div>
        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 pt-7">
          <p className="font-tech text-[10px] uppercase tracking-[0.25em] text-white/35">
            © {new Date().getFullYear()} Mobile One Audio — New Castle, DE
          </p>
          <button
            data-testid="footer-top-button"
            onClick={() => scrollTo(0)}
            className="font-tech text-[10px] uppercase tracking-[0.25em] text-white/50 hover:text-[#FF5500] transition-colors"
          >
            Back to top
          </button>
        </div>
      </div>
    </footer>
  );
}
